<template>
  <div class="user-manager">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>User Manager</span>
      </div>
      <el-button type="primary" icon="el-icon-plus" @click="showUpdateModal(actions.add, null)">Add New User</el-button>
      <el-row>
        <el-col>
          <data-tables v-loading="loading" :data="tableData" border :page-size="10" :pagination-props="{ background: true, pageSizes: [5, 10, 20, 50, 100] }" style="width:100%">
            <el-table-column prop="fullname" label="User name" header-align="center" align="center" width="250" fixed></el-table-column>
            <el-table-column prop="email" label="Email" header-align="center" align="center" width="350"></el-table-column>

            <el-table-column prop="admin" label="Role" header-align="center" align="center">
              <template slot-scope="scope">
                {{ scope.row.admin ? "Admin" : "User" }}
              </template>
            </el-table-column>
            <el-table-column prop="lastlogindate" label="Last Login" header-align="center" align="center">
              <template slot-scope="scope">
                {{ dateFormat(scope.row.lastlogindate) }}
              </template>
            </el-table-column>
            <el-table-column prop="lastactive" label="Last Active" header-align="center" align="center">
              <template slot-scope="scope">
                {{ dateFormat(scope.row.lastactive) }}
              </template>
            </el-table-column>
            <el-table-column prop="uid" label="Operations" header-align="center" align="center" width="120" fixed="right">
              <template slot-scope="scope">
                <el-button type="primary" icon="el-icon-edit" @click="showUpdateModal(actions.edit, scope.row.uid)" circle size="mini"></el-button>
                <el-button type="danger" icon="el-icon-delete"  @click="showDeleteModal(scope.row.uid, scope.row.fullname)" circle size="mini"></el-button>
              </template>
            </el-table-column>
          </data-tables>

        </el-col>
      </el-row>
    </el-card>

    <div class="dialog">
    <el-dialog :title="renderTitle()" :visible.sync="dialogFormEditUserVisible" @closed="dialogClosed('userForm')" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="userForm" :rules="rules" ref="userForm">
        <el-form-item label="Username" prop="fullname" :label-width="formLabelWidth">
          <el-input v-model="userForm.fullname" autocomplete="off" placeholder="Please enter Username"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email" :label-width="formLabelWidth">
          <el-input v-model="userForm.email" autocomplete="off" placeholder="Please enter Email"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password" :label-width="formLabelWidth">
          <password v-model="userForm.password" autocomplete="off" @feedback="showPasswordFeedback" :showPassword="true"  placeholder="Please enter password" referenceValue="userPassword"></password>
        </el-form-item>
        <el-form-item label="Role" prop="admin" :label-width="formLabelWidth">
          <el-select v-model="userForm.admin" placeholder="Please select Role">
            <el-option
              v-for="item in roleOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
          <el-button style="float:right" type="success" icon="el-icon-set-up" @click="generatePassword()">Generate Password</el-button>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogFormEditUserVisible = false">Cancel</el-button>
        <el-button type="primary" @click="submitForm('userForm')">Update User</el-button>
      </span>
    </el-dialog>
    </div>
  </div>
</template>

<script>
import Password from "vue-password-strength-meter";
import utility from "@/components/utility";
import user from "@/api/user";
export default {
  components: { Password },
  data() {

    var validateEmail = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Email required."));
      } else {
        var mailformat = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!value.match(mailformat)){
          callback(new Error("Valid email required."));
        }else{
          callback();
        }
        
      }
    };

    var validatePassword = (rule, value, callback) => {
      if (this.actionActive === this.actions.add && value === "") {
        callback(new Error("Password required."));
      }else if(!this.strongpassword && value){
        callback(new Error("Add another word or two. Uncommon words are better."));
      } else {
        callback()
      }
    }
    var validateAdmin = (rule, value, callback) => {
      if (this.actionActive === this.actions.add && value === "") {
        callback(new Error("Password required."));
      }else {
        callback()
      }
    }

    return {
      tableData : [],
      loading: true,
      dialogFormEditUserVisible: false,
      userForm: {
        uid: "",
        fullname: "",
        email: "",
        password: "",
        admin: ""
      },
      formLabelWidth: '120px',
      actions:{
        add: 1,
        edit: 2
      },
      actionActive: 0,
      roleOptions: [
        {
          id: 0,
          name: "User"
        },
        {
          id: 1,
          name: "Admin"
        }
      ],
      rules: {
        fullname: [{ required: true, message: 'required', trigger: 'blur' }],
        email: [{ trigger: "blur", validator: validateEmail }],
        password: [{ trigger: "blur", validator: validatePassword }],
        admin: [{ trigger: "blur", validator: validateAdmin }]
      },
      strongpassword: false
    };
  },
  methods: {
    renderTitle(){
      if(this.actionActive === this.actions.add) return 'Add User';
      if(this.actionActive === this.actions.edit) return 'Edit User';
    },
    showPasswordFeedback ({suggestions, warning}) {
      if(suggestions.length === 0 && !warning){
        this.strongpassword = true
      }else{
        this.strongpassword = false
      }
    },
    getUserLists() {
      const data = {
        customercode : this.$store.getters.user.customercode
      }
      user.getUserLists(data).then( res => {
        if (res && res["result"]) {
          this.tableData = res["data"];
          this.loading = false
        }
      })
    },
    dateFormat(date){
      let dateOutput = utility.dateFormat(date, 'DD MMMM YYYY HH:mm A')
      return dateOutput === 'Invalid date' ? '' : dateOutput 
    },
    showUpdateModal(action, uid){
      this.actionActive = action
      if(action === this.actions.add){
          this.userForm = {
            fullname: "",
            email: "",
            password: "",
            admin: 0
          }
          this.dialogFormEditUserVisible = true
      }

      if(action === this.actions.edit){
        user.getByUID({ uid: uid}).then( res =>{
          if (res && res["result"]) {
            const data = res["data"];
            this.userForm.uid = data.uid;
            this.userForm.fullname = data.fullname;
            this.userForm.email = data.email;
            this.userForm.admin = data.admin;
            this.dialogFormEditUserVisible = true
          }
          
        })
      }
    },
    showDeleteModal(uid, username){
      this.$confirm(`Are you sure you want to delete user ${username} ?`, 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          user.delete({ uid: uid}).then( res =>{
            if (res && res["result"]) {
              this.getUserLists();
              this.$message({
                type: 'success',
                message: 'Delete completed'
              });
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled'
          });          
        });
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if(valid){
          const data = {
            uid: this.userForm.uid,
            fullname : this.userForm.fullname,
            email : this.userForm.email,
            password: this.userForm.password,
            admin: this.userForm.admin,
            customercode: this.$store.getters.user.customercode
          }
          
          if(this.actionActive === this.actions.add) this.addUser(data)
          if(this.actionActive === this.actions.edit) this.editUser(data)
          
        }
      })

    },
    addUser(data){
      user.add(data).then( res =>{
        if (res && res["result"]) {
          this.getUserLists();
          this.dialogFormEditUserVisible = false
        }
      })
    },
    editUser(data){
      user.edit(data).then( res =>{
        if (res && res["result"]) {
          this.getUserLists();
          this.dialogFormEditUserVisible = false
        }
      })
    },
    dialogClosed(formName) {
      this.actionActive = 0
      this.$refs[formName].resetFields()
    },
    generatePassword(){
      var length = 16,
        charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789!@#$%^&*",
        retVal = "";
      for (var i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
      }

      this.userForm.password = retVal
      this.$refs['userForm'].$el[2].focus();
    }
  },
  created() {
    this.getUserLists();
  }
};

</script>

<style lang="scss">
.user-manager{
  .sc-table{
    border: 1px solid #EBEEF5;
   }
  .el-table th.is-leaf{
    background-color: rgb(121, 136, 150);
    color: #ffffff;
  }
  .el-table th.is-leaf, .el-table td {
    border-bottom: 1px solid #EBEEF5;
    border-right: 1px solid #EBEEF5;
  }

  .pagination-bar{
    margin-top: 10px;
  }

  .Password{
    max-width: 100%;
  }

 }
</style>